import dayjs from "dayjs";

export const formatDate = (date: string | Date) => {
  return dayjs(date).format("YYYY/MM/DD");
};

export const formatDateTime = (dateTime: string | Date) => {
  return dayjs(dateTime).format("YYYY/MM/DD HH:mm:ss");
};
